import { render, staticRenderFns } from "./BatchesCalendar.vue?vue&type=template&id=39f08754&scoped=true"
import script from "./BatchesCalendar.vue?vue&type=script&lang=js"
export * from "./BatchesCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f08754",
  null
  
)

export default component.exports